export const LIVE = 1;
export const ESSAY_REVIEW = 2;
